module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/wob-decoding-indias-labour-codes.json
// module id = 1537
// module chunks = 264079351629323